import { render } from "./RoomItem.vue?vue&type=template&id=e339e150&scoped=true"
import script from "./RoomItem.vue?vue&type=script&lang=js"
export * from "./RoomItem.vue?vue&type=script&lang=js"

import "./RoomItem.vue?vue&type=style&index=0&id=e339e150&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e339e150"]])

export default __exports__